import { FormControl } from '@angular/forms';
//checks type NgbDateStruct, ex: {year: 2018, month: 4, day: 7}
export function ValidateDate(c: FormControl) {
  let validDate = false;
  if (c.value) {
    if (c.value.day > 0 && c.value.day <= 31 && c.value.month > 0 && c.value.month <= 12 && c.value.year.toString().length === 4) {
      validDate = true;
    }
    else {
      validDate = false;
    }
  }
  return validDate === false ? { invalidDate: true } : null;
}


// WEBPACK FOOTER //
// ./src/app/date-validator.ts